"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadAttributeByDisplayForm = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var sdk_ui_1 = require("@gooddata/sdk-ui");
/**
 * @internal
 */
function loadAttributeByDisplayForm(context, displayFormRef) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            return [2 /*return*/, context.backend
                    .workspace(context.workspace)
                    .attributes()
                    .getAttributeByDisplayForm(displayFormRef)
                    .catch(function (err) {
                    // Convert from AnalyticalBackendError to GoodDataSdkError
                    throw sdk_ui_1.convertError(err);
                })];
        });
    });
}
exports.loadAttributeByDisplayForm = loadAttributeByDisplayForm;
//# sourceMappingURL=loadAttributeByDisplayForm.js.map